import {createRouter, createWebHistory} from "vue-router"
import {Layout} from "@/types/theme.d"
import {useAuthStore} from "@/stores/auth"
import {useNotificationsStore} from "@/stores/useNotificationsStore"
import type {FormType} from "@/components/auth/types.d"
import {Logger} from "@/utils"

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: "/",
            redirect: "/dashboard"
        },
        // {
        // 	path: "/calendar",
        // 	name: "Apps-Calendars-FullCalendar",
        // 	component: () => import("@/views/Apps/Calendars/FullCalendar.vue"),
        // 	meta: { title: "Calendar", auth: true, roles: "all" }
        // },
        /*
        {
            path: "/calendars",
            redirect: "/calendars/vue-cal",
            meta: {
                auth: true,
                roles: "all"
            },
            children: [
                {
                    path: "vue-cal",
                    name: "vue-cal",
                    component: () => import("@/views/Apps/Calendars/VueCal.vue"),
                    meta: { title: "Vue Cal" }
                },
                {
                    path: "full-calendar",
                    name: "full-calendar",
                    component: () => import("@/views/Apps/Calendars/FullCalendar.vue"),
                    meta: { title: "Full Calendar" }
                }
            ]
        },
        */
        {
            path: "/academy",
            name: "Apps-Academy",
            component: () => import("@/views/Apps/Academy.vue"),
            meta: {title: "Academy", auth: true, roles: "all"}
        },
        {
            path: "/forum",
            name: "Apps-Forum",
            component: () => import("@/views/Apps/Forum.vue"),
            meta: {title: "Forum", auth: true, roles: "all"}
        },
        {
            path: "/chat",
            name: "Apps-Chat",
            component: () => import("@/views/Apps/Chat.vue"),
            meta: {title: "Chat", auth: true, roles: "all"}
        },
        {
            path: "/dashboard",
            name: "Dashboard",
            component: () => import("@/views/Apps/News.vue"),
            meta: {title: "Dashboard", auth: true, roles: "all"}
        },
        {
            path: "/connections",
            redirect: "/connections/players",
            name: "Connections",
            meta: {
                title: "Connections",
                auth: true,
                roles: "all"
            },
            children: [
                {
                    path: "players",
                    name: "Community-Players",
                    component: () => import("@/views/Community/Players.vue"),
                    meta: {title: "Players"}
                },
                {
                    path: "trainers",
                    name: "Community-Trainers",
                    component: () => import("@/views/Community/Trainers.vue"),
                    meta: {title: "Trainers"}
                },
                {
                    path: "managers",
                    name: "Community-Managers",
                    component: () => import("@/views/Community/Managers.vue"),
                    meta: {title: "Managers"}
                },
                {
                    path: "clubs",
                    name: "Community-Clubs",
                    component: () => import("@/views/Community/Clubs.vue"),
                    meta: {title: "Clubs"}
                }
            ]
        },
        {
            path: "/profile",
            name: "Profile",
            component: () => import("@/views/MyProfile.vue"),
            meta: {title: "Profile", auth: true, roles: "all"}
        },
        {
            path: "/profile/:id",
            name: "User-Profile",
            component: () => import("@/views/UserProfile.vue"),
            meta: {title: "User-Profile", auth: true, roles: "all"}
        },

        {
            path: "/login",
            name: "Login",
            component: () => import("@/views/Auth/Login.vue"),
            meta: {title: "Login", forceLayout: Layout.Blank, checkAuth: true, skipPin: true}
        },
        {
            path: "/register",
            name: "Register",
            component: () => import("@/views/Auth/Login.vue"),
            props: {formType: "signup" as FormType},
            meta: {title: "Register", forceLayout: Layout.Blank, checkAuth: true, skipPin: true}
        },
        {
            path: "/forgot-password",
            name: "ForgotPassword",
            component: () => import("@/views/Auth/Login.vue"),
            props: {formType: "forgotpassword" as FormType},
            meta: {title: "Forgot Password", forceLayout: Layout.Blank, checkAuth: true, skipPin: true}
        },
        {
            path: "/logout",
            name: "Logout",
            component: () => null,
            meta: {title: "Logout", forceLayout: Layout.Blank, skipPin: true}
            //redirect: "/login"
        },
        {
            path: "/:pathMatch(.*)*",
            name: "NotFound",
            component: () => import("@/views/NotFound.vue"),
            meta: {forceLayout: Layout.Blank, skipPin: true}
        }
    ]
})

router.beforeEach((to, from, next) => {
    const authStore = useAuthStore()
    const notifications = useNotificationsStore()

    // Handle logout route
    Logger.debug("Router before each", to, from)
    /*if (to.name === "Logout") {
        notifications.closeMercureSubscription().then(() => {
            //notifications.unsubscribeWebPushSubscription().then(() => {
                notifications.updateAppPushNotificationSignOut().then(() => {
                    authStore.setLogout()
                    next({name: "Login"})
                })
            //})
        })
        return
    }*/

    // Check if route requires authentication
    if (to.meta.auth && !authStore.logged) {
        next({name: "Login", query: {redirect: to.fullPath}})
        return
    }

    // Check if user has required roles
    if (to.meta.auth && to.meta.roles && !authStore.isRoleGranted(to.meta.roles)) {
        next({name: "Login"})
        return
    }

    // Check if already logged in user tries to access auth pages
    if (to.meta.checkAuth && authStore.logged) {
        const redirectPath = from.query.redirect as string || to.meta.authRedirect as string || "/"
        next(redirectPath)
        return
    }

    // Allow navigation
    next()
})

export default router
